
import * as utils from "../utils/utils.js";
let padding = { top:0, right:15, bottom:30, left:15};


export function createVolcanoPoints(data){
    return data.map(d=>{
        return {
            x: d.lf,
            y: d.p,
            r: utils.circle.r,
            c: utils.circle.c,
            series: d.g,
            _info: d
        }
    })
}

export function createScatterPoints(data){
    return data.map(d=>{
        return {
            x: d.lf[0],
            y: d.lf[1],
            r: utils.circle.r,
            c: utils.circle.c,
            series: d.g,
            _info: d
        }
    })
}
export function createBarcodePoints(data){
    return data.map(d=>{
        return {
            x: d.p,
            y: 10,
            c: d.s,
            series: d.g,
            _info: d
        }
    })
}
export function createLinePoints(data){
    return data.map(d=>{
        return {
            x: d.c,
            y: +d.v,
            c: d.s,
            series: d.g,
            _info: d
        }
    })
}
export function createColumnPoints(data){
    return data.map(d=>{
        return {
            x: d.c,
            y: +d.v,
            c: +d.v,
            series: d.g,
            _info: d
        }
    })
}
export function createHeatmapData(data){
    return data.map((d,i)=>{
        return {
            row: i,
            column: 0,
            key: d.cl,
            type:"scatterplot",
            title: utils.dict().cellLine[d.cl],
            padding: padding,
            _data: d.hist.map(e=>{ return { x: e[0], y: e[1], c: e[2] } }).filter(e=> e.c>0),
            data: [],
            axis: {
                x:{
                    min:utils.extents().volcano.x[0],
                    max:utils.extents().volcano.x[1],
                    type:"linear",
                    hideAxis: true,
                    title: ``
                },
                y: {
                    min:utils.extents().volcano.y[0],
                    max:utils.extents().volcano.y[1],
                    type:"linear",
                    hideAxis: true,
                    title: ``
                }
            },
            _info: d,
        }
    })
}
export function createHistogramData(data){
      return data.map((d,i)=>{
                return {
                    row: i,
                    column: 1,
                    key: d.cl,
                    type:"areaplot",
                    title: "",
                    padding: padding,
                    data: d.hist.map(e=>{ return { x: e[0], y: e[1] } }),
                    axis: {
                        x:{
                            hideAxis: true,
                            title: ``,
                            scaleType: "linear"
                         
                        },
                        y: {
                            hideAxis: true,
                            title: ``,
                            scaleType: "linear",
                            nice:true
                          
                        }
                    },
                    _info: d
                    
                }
            })
}
export function createLineplotData(data, userInput){
     return data.map(d=>{
                let xDomain;
                if (userInput.l == "p"){
                    xDomain = utils.cellLineConditions[d.key]
                } else {
                    xDomain = utils.cellLineConditions.B
                }
                return {
                    row: d.row,
                    column: 2,
                    key: d.key,
                    padding:d.padding,
                    data: [],
                    type: "columnplot",
                    axis: {
                        x:{
                            domain: xDomain,
                            title: "",
                            hideAxis: true,
                            scaleType: "categorical"
                        },
                        y:{
                            title: "",
                            hideAxis: true,
                            scaleType: "linear"
                        }
                     }
                }
            })
}
export function createColumnplotData(data){
              return data.map(d=>{
                return {
                    row: d.row,
                    column: 3,
                    key: d.key,
                    padding:d.padding,
                    data: [],
                    type: "columnplot",
                    axis: {
                        x:{
                            title: "",
                            hideAxis: true,
                            scaleType: "categorical",
                      
                        },
                        y:{
                            title: "",
                            hideAxis: true,
                            scaleType: "linear",
                            nice:true
                        }
                     }
                }
            })
}